import * as UI from "@accurx/design";
import styled from "styled-components";

const Inner = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    width: 100%;
    max-width: ${UI.Tokens.BREAKPOINTS.md};
    margin: 1rem;
`;

const Outer = styled.div`
    display: flex;
    justify-content: center;
    flex: 1;
    width: 100%;
    background-color: var(--ds-color-cloud);
`;

export const Container = { Inner, Outer };
